<template>
  <div class="card">
    <div class="card-body">
      <b-carousel
        id="carousel-example-generic"
        controls
        img-width="100"
        img-height="100" v-if="eduPrograms.length>0"
      
      >
        <b-carousel-slide   v-for="eduProgram in eduPrograms"
        :key="eduProgram.id">
          <template #img>
            <div
              class="
                d-flex
                justify-content-center
                align-items-center
                flex-column
              "
            >
              <a :href="'/edu_programs/' + eduProgram.id">
                <img
                  class=""
                  width="100"
                  height="100"
                  src="@/assets/images/slider/noun_lesson_1766585.svg"
                  alt="image slot"
                />
              </a>

              <h2>  {{ eduProgram.name }}</h2>
              <div class="mt-10 text-center">
                <a variant="outline-primary"  :href="'/edu_programs/' + eduProgram.id"
                  ><span
                    ><svg
                      id="Group_46"
                      data-name="Group 46"
                      xmlns="http://www.w3.org/2000/svg"
                      width="28.997"
                      height="26.9"
                      viewBox="0 0 28.997 26.9"
                    >
                      <path
                        id="Path_60"
                        data-name="Path 60"
                        d="M13.465,54.329h1.55c0-.091-.046-.228-.046-.365a1,1,0,0,1,.046-.365h-1.55a.365.365,0,1,0,0,.729Z"
                        transform="translate(-7.902 -30.986)"
                        fill="#261b15"
                      ></path>
                      <path
                        id="Path_61"
                        data-name="Path 61"
                        d="M25.646,53.965a1,1,0,0,1-.046.365H38.138a.365.365,0,1,0,0-.729H25.646Z"
                        transform="translate(-14.703 -30.986)"
                        fill="#261b15"
                      ></path>
                      <path
                        id="Path_62"
                        data-name="Path 62"
                        d="M28.509,20.3H3.888A2.189,2.189,0,0,0,1.7,22.488V37.58a2.189,2.189,0,0,0,2.188,2.188h24.62A2.189,2.189,0,0,0,30.7,37.58V22.443A2.18,2.18,0,0,0,28.509,20.3ZM3.934,32.018a.36.36,0,0,1-.365.365.323.323,0,0,1-.319-.365V28.005a.36.36,0,0,1,.365-.365.336.336,0,0,1,.365.365v4.012Zm0-5.38A.36.36,0,0,1,3.569,27a.336.336,0,0,1-.365-.365v-.182a.36.36,0,0,1,.365-.365.336.336,0,0,1,.365.365ZM27.278,37.443H5.12V22.58H27.278Zm1.55-6.885a.554.554,0,0,1-.547-.547.547.547,0,0,1,1.094,0A.554.554,0,0,1,28.828,30.559Z"
                        transform="translate(-1.7 -12.868)"
                        fill="#261b15"
                      ></path>
                      <path
                        id="Path_63"
                        data-name="Path 63"
                        d="M30.562,31.424A2.462,2.462,0,1,0,28.1,28.962,2.452,2.452,0,0,0,30.562,31.424Z"
                        transform="translate(-16.063 -16.241)"
                        fill="#261b15"
                      ></path>
                      <path
                        id="Path_64"
                        data-name="Path 64"
                        d="M21.945,43.406H32.158a.36.36,0,0,0,.365-.365V41.765A3.464,3.464,0,0,0,29.057,38.3H25.136a3.464,3.464,0,0,0-3.465,3.465v1.277C21.58,43.27,21.762,43.406,21.945,43.406Z"
                        transform="translate(-12.552 -22.661)"
                        fill="#261b15"
                      ></path>
                      <path
                        id="Path_65"
                        data-name="Path 65"
                        d="M22.979,6.553a6.329,6.329,0,0,1,8.936,0,.331.331,0,0,0,.456,0,.358.358,0,0,0,0-.5,6.99,6.99,0,0,0-9.894,0,.355.355,0,0,0,.5.5Z"
                        transform="translate(-12.949 -4)"
                        fill="#261b15"
                      ></path>
                      <path
                        id="Path_66"
                        data-name="Path 66"
                        d="M32.471,10.552a.348.348,0,0,0,.228-.091.358.358,0,0,0,0-.5,4.953,4.953,0,0,0-7.021,0,.355.355,0,0,0,.5.5,4.167,4.167,0,0,1,3.009-1.231A4.361,4.361,0,0,1,32.2,10.461.648.648,0,0,0,32.471,10.552Z"
                        transform="translate(-14.69 -6.448)"
                        fill="#261b15"
                      ></path>
                      <path
                        id="Path_67"
                        data-name="Path 67"
                        d="M28.878,13.88a.355.355,0,1,0,.5.5,2.229,2.229,0,0,1,3.146,0,.331.331,0,0,0,.456,0,.358.358,0,0,0,0-.5A2.889,2.889,0,0,0,28.878,13.88Z"
                        transform="translate(-16.431 -8.91)"
                        fill="#261b15"
                      ></path>
                      <path
                        id="Path_68"
                        data-name="Path 68"
                        d="M19.977,54.153a1.274,1.274,0,0,0,1.277-1.277A1.247,1.247,0,0,0,19.977,51.6a1.277,1.277,0,1,0,0,2.553Z"
                        transform="translate(-10.949 -29.898)"
                        fill="#261b15"
                      ></path></svg
                  ></span>
                  مشاهدة البرامج التعليمية</a
                >
              </div>
            </div>
          </template>
        </b-carousel-slide>
        <!--  -->
      </b-carousel>
       <b-spinner v-else type="grow" label="Loading..."  class="loading" />
    </div>
  </div>
</template>

<script>
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
export default {

  props: {
    eduPrograms: [],
  },
};
</script>

<style>
.carousel-control-prev,
.carousel-control-next {
  background: #ccc;
  width: 10px;
}
</style>
